import SearchServices from './services';

export default {

  data: {
    $el: $('#search'),
    results: [],
    filter: 'all',
    query: null,
    page: 1,
    results_per_page: 10,
    results_loading: false
  },

  computed: {
    filteredResults() {
      if (this.filter === 'all') {
        return this.results;
      } else {
        return this.results.filter((result) => {
          return result.type === this.filter;
        });
      }
    }
  },

  methods: {
    bindData(data) {
      console.log('binddata', data);
      this.results = data.results;
      this.query = data.meta.query;
      this.page = data.meta.page;
      this.results_per_page = data.meta.per_page;
    },

    changeFilter(filter) {
      this.filter = filter;
      this.page = 0;
      this.loadResults(true);
    },

    highlightValue(result,key){
      return SearchServices.highlightValue(result,key);
    },
    highlightType(result){
      return SearchServices.highlightType(result);
    },
    highlightInstructors(result) { 
      return SearchServices.highlightInstructors(result);
    },
    highlightDescription(result){
      return SearchServices.highlightDescription(result);
    },
    searchResultOnClick(result) {
      SearchServices.searchResultOnClick(result,this.query);
    },
    loadResults(append, url) {
      if(append){
        Kadenze.UIUtil.showLoadingIndicator($('.search__results'));
      }
      this.results_loading = true;
      this.page += 1;
      url = url || Kadenze.Routes.search_path({
        q: this.query,
        page: this.page,
        per_page: this.results_per_page,
        filter: this.filter
      });

      let request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        dataAsJSON: false,
        timeout: 60000
      });
      request.done(data => {
        Kadenze.UIUtil.hideLoadingIndicator($('.search__results'));
        if(append){
          this.results = this.results.concat(data.results);
        } else {
          this.results = data.results;
        }
        this.results_loading = false;
      });
    },

    attachScrollEventListener() {
      $(window).off('scroll.searchResultsLoadMore').on('scroll.searchResultsLoadMore', _.debounce(() => {
        let $scrollTarget = $('#loadMoreResults'),
          topOffset = $scrollTarget.offset().top,
          outerHeight = $scrollTarget.outerHeight(),
          windowHeight = $(window).height(),
          scrollTop = $(window).scrollTop();

        if(scrollTop > (topOffset + outerHeight - windowHeight)) {
          this.loadMoreResults();
        }
      }, 250));
    },
    loadMoreResults() {
      this.loadResults(true);
    }
  },

  mounted() {
    this.attachScrollEventListener();
  }
};
